module.exports = __webpack_public_path__ + "f0e661e7e07c0eea02ba2776aaa59e25.png";